import { combineReducers } from 'redux';
import { Reducer } from '../../../types';
import { CancelOrderState, OrderAction } from '../types';

import {
  cancelOrderRequest,
  cancelOrderSuccess,
  cancelOrderFail,
} from '../actions';



type ReducerOf<T extends keyof CancelOrderState> = Reducer<CancelOrderState, OrderAction, T>;

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case cancelOrderRequest.type:
      return true;

    case cancelOrderSuccess.type:
    case cancelOrderFail.type:
      return false;

    default:
      return state;
  }
};


export default combineReducers<CancelOrderState>({
  loading,
});
